import { Children, isValidElement } from 'react';
import './Forms.css';

export function RequiredMarker() {
  // The control's native `required` state is announced by screen readers.
  return <span className="required-marker" aria-hidden="true" />;
}

export function RequiredFieldsNote() {
  return <p className="form-required-note">Fields marked * are required.</p>;
}

// Wrapped controls supply their own required state, including conditional fields.
// Pass `required` explicitly for labels connected to a separate control by htmlFor.
export default function FieldLabel({ children, required, ...props }) {
  const parts = Children.toArray(children);
  const controlIndex = parts.findIndex(child => isValidElement(child) && ['input', 'select', 'textarea'].includes(child.type));
  const isRequired = required ?? parts[controlIndex]?.props.required;
  if (!isRequired) return <label {...props}>{children}</label>;
  const leading = controlIndex < 0 ? parts : parts.slice(0, controlIndex);
  const isHelp = child => isValidElement(child) && child.type === 'small';
  return <label {...props}>
    <span className="form-label-text">{leading.filter(child => !isHelp(child))}<RequiredMarker /></span>
    {leading.filter(isHelp)}
    {controlIndex < 0 ? null : parts.slice(controlIndex)}
  </label>;
}
